import PricingController from '../pricing_controller.js'
import { useDebounce } from 'stimulus-use'

export default class extends PricingController {
  static debounces = [{ name: 'updatePrice' }]

  static targets = [
    'costPerCredit',
    'errorMessage',
    'itemBreakdown',
    'input',
    'itemTotal',
    'totalCredits',
    'totalPrice'
  ]

  static values = {
    costs: Object,
    enterpriseThreshold: Number,
    enterpriseVisible: { type: Boolean, default: false },
    maxCredits: Number
  }

  // Public methods (alphabetical order)

  connect() {
    useDebounce(this)
  }

  async updatePrice() {
    this.#setLoading()

    const response = await this.requestPrice('credits', this.#getTotalCredits())

    if (!response.ok) {
      this.errorMessageTarget.hidden = false
      return this.#clearLoading()
    }

    const data = await response.json()

    this.#clearLoading()

    this.totalPriceTarget.textContent = data.payg.amount.formatted
    this.costPerCreditTarget.textContent = data.payg.cpc.formatted

    this.updateCurrency(data.currency)
  }

  updateSummary() {
    const totalCredits = this.#getTotalCredits()

    this.itemBreakdownTargets.forEach(breakdownEl => {
      const id = breakdownEl.dataset.controlId
      const cost = this.costsValue[id]
      const input = this.inputTargets.find(
        input => input.dataset.controlId === id
      )

      let amount = this.#sanitizeInput(input.value)
      const totalEls = this.itemTotalTargets.filter(
        el => el.dataset.controlId === id
      )

      if (amount > parseInt(input.max)) amount = input.max
      if (amount < parseInt(input.min)) amount = input.min

      breakdownEl.textContent = amount.toLocaleString()
      totalEls.forEach(
        el => (el.textContent = (amount * cost).toLocaleString())
      )
    })

    this.totalCreditsTarget.textContent = totalCredits.toLocaleString()
    this.enterpriseVisibleValue = totalCredits > this.enterpriseThresholdValue
  }

  #clearLoading() {
    clearTimeout(this.loadingTimeout)
    this.skeletonTargets.forEach(el => (el.dataset.loading = false))
  }

  #getTotalCredits() {
    let totalCredits = 0

    this.inputTargets.forEach(input => {
      const value = this.#sanitizeInput(input.value)
      const credits = value * this.costsValue[input.dataset.controlId]
      totalCredits += credits
    })

    return totalCredits
  }

  #sanitizeInput(value) {
    // strip out any non-numeric characters and return value as an integer
    value = value.replace(/[.,]/g, '').replace(/^0+(?!\.|$)/, '')
    value = parseInt(value)
    if (isNaN(value)) value = 0
    return value
  }

  #setLoading() {
    // show loading state if request time > 300ms
    this.loadingTimeout = setTimeout(() => {
      this.errorMessageTarget.hidden = true
      this.skeletonTargets.forEach(el => (el.dataset.loading = true))
    }, 300)
  }
}
